// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  CurrencyInput,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { MAX_OFFERS } from '../../RenewalOfferForm/helpers';
import messages from '../../messages';

type RenderTermCostProps = {
  cost: number | string,
  providerName?: ?string,
};

export const RenderTermCost = ({ cost, providerName }: RenderTermCostProps) => {
  const providerCaption = providerName && (
    <FormattedMessage
      {...messages.poweredByProvider}
      values={{ provider: providerName }}
    />
  );

  return (
    <Box flex={1} data-test="previous-offer-cost">
      <CurrencyInput
        value={isNaN(cost) ? '' : cost}
        disabled
        fullWidth
        // See CostField/index.js for the helper-text/placeholder convention.
        helperText={providerCaption || ' '}
        FormHelperTextProps={
          providerCaption
            ? { 'data-test': 'previous-offer-provider' }
            : undefined
        }
      />
    </Box>
  );
};

type Props = {
  rents: Array<number | string>,
  providerNames?: Array<?string>,
};

const OfferRentRow = ({ rents, providerNames = [] }: Props) => (
  <>
    {Array.from({ length: MAX_OFFERS }, (_, i) => i).map((i) => (
      <RenderTermCost key={i} cost={rents[i]} providerName={providerNames[i]} />
    ))}
    <Box sx={{ width: 40, flexShrink: 0 }} />
  </>
);

export default OfferRentRow;
